import BaseModel from '../core/BaseModel'
import AreaModel from "@/models/AreaModel";
//import gql from 'graphql-tag'
export default class ReportDocsTdvModel extends BaseModel {

    constructor() {
        super({ 
                name: "reportdocstdv",
                tableName: 'users', 
                label: "Báo cáo văn bản tổng hợp nhân viên", 
                display_key: 'fullname', 
                default_order: { key: 'created_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "String",
                width: 4,
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            code: {
                name: 'code', 
                type: "String",
                label: 'Mã nhân viên',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            fullname: {
                name: 'fullname', 
                type: "String",
                label: 'Tên nhân viên',
                width: 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false,
            },
                area_id: {
                name: "area_id",
                label: "Mã khu vực",
                width: 9,
                class: "center",
                type: "Selection",
                models: new AreaModel(),
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            areas: {
                refs: 'areas {id name:code}',
                display: false
            },
            // doc_confirmed_ref: {
            //     refs: 'view_tdv_total_doc_confirmed_aggregate {aggregate {count}}',
            //     display: false
            // },
            col_total_received_documents_not_scanned: {
                name: 'col_total_received_documents_not_scanned', 
                type: "Computed",
                label: 'Tổng VB nhận chưa scan ( tổng VB đã xác nhận)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.col_total_received_documents_not_scanned = data?.total_received_documents_not_scanned?.aggregate?.count
                },
            },
            // doc_waiting_no_scan_ref: {
            //     refs: 'view_tdv_total_doc_waiting_no_scan_aggregate {aggregate {count}}',
            //     display: false
            // },
            col_total_number_of_documents_being_served: {
                name: 'col_total_number_of_documents_being_served', 
                type: "Computed",
                label: 'Tổng số VB đang TĐ',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.col_total_number_of_documents_being_served = data?.total_number_of_documents_being_served?.aggregate?.count
                },
            },
            // doc_normal_tt_gn_nt3_ref: {
            //     refs: 'view_tdv_total_doc_normal_tt_gn_nt3_aggregate {aggregate {count}}',
            //     display: false
            // },
            col_total_docs_sent_back_to_unit: {
                name: 'col_total_docs_sent_back_to_unit', 
                type: "Computed",
                label: 'Tổng số VB đã trả ĐPV',
                width: 12,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.col_total_docs_sent_back_to_unit = data?.total_docs_sent_back_to_unit?.aggregate?.count
                },
            },
            col_total_documents_received_by_coordinator: {
                name: 'col_total_documents_received_by_coordinator', 
                type: "Computed",
                label: 'Tổng số VB ĐPV đã nhận',
                width: 12,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.col_total_documents_received_by_coordinator = data?.total_documents_received_by_coordinator?.aggregate?.count
                },
            },
            // doc_doc_normal_kt_ref: {
            //     refs: 'view_tdv_total_doc_normal_kt_aggregate {aggregate {count}}',
            //     display: false
            // },
            col_total_documents_resubmitted: {
                name: 'col_total_documents_resubmitted', 
                type: "Computed",
                label: 'Tổng số VB hoàn thiện lại',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.col_total_documents_resubmitted = data?.total_documents_resubmitted?.aggregate?.count
                },
            },
            // doc_doc_normal_ny_ref: {
            //     refs: 'view_tdv_total_doc_normal_ny_aggregate {aggregate {count}}',
            //     display: false
            // },
            col_total_documents_completed: {
                name: 'col_total_documents_completed', 
                type: "Computed",
                label: 'Tổng số VB hoàn thành',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.col_total_documents_completed = data?.total_documents_completed?.aggregate?.count
                },
            },
            // doc_doc_type3_ref: {
            //     refs: 'view_tdv_total_doc_type3_aggregate {aggregate {count}}',
            //     display: false
            // },
            col_total_docs_returned_to_agency : {
                name: 'col_total_docs_returned_to_agency', 
                type: "Int",
                label: 'Tổng số VB đã trả cơ quan',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.col_total_docs_returned_to_agency = data?.total_docs_returned_to_agency?.aggregate?.count
                },
            },
            // doc_doc_type4_ref: {
            //     refs: 'view_tdv_total_doc_type4_aggregate {aggregate {count}}',
            //     display: false
            // },
            col_total_documents_processed_for_salary: {
                name: 'col_total_documents_processed_for_salary', 
                type: "Int",
                label: 'Tổng số VB đã tính lương',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.col_total_documents_processed_for_salary = data?.total_documents_processed_for_salary?.aggregate?.count
                },
            },
            // doc_doc_type5_ref: {
            //     refs: 'view_tdv_total_doc_type5_aggregate {aggregate {count}}',
            //     display: false
            // },
            total_doc_sum: {
                name: 'total_doc_sum', 
                type: "Int",
                label: 'Tổng VB',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_sum = data?.total_doc_sum_key ?? 0;
                },
            },
            total_doc_done_sum: {
                name: 'total_doc_done_sum', 
                type: "Int",
                label: 'Tổng VB hoàn thành',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_done_sum = data?.total_doc_done_sum_key ?? 0;
                },
            },
            // doc_doc_remaining_ref: {
            //     refs: 'view_tdv_total_doc_remaining_aggregate {aggregate {count}} view_tdv_total_doc_complete_aggregate {aggregate {count}}',
            //     display: false
            // },
            total_inventory: {
                name: 'total_inventory',
                type: "Int",
                label: 'Tổng tồn',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    /*var total_doc_normal_tt_gn_nt3 = data.view_tdv_total_doc_normal_tt_gn_nt3_aggregate.aggregate.count;
                    var total_doc_normal_kt = data.view_tdv_total_doc_normal_kt_aggregate.aggregate.count;
                    var total_doc_normal_ny = data.view_tdv_total_doc_normal_ny_aggregate.aggregate.count;
                    var total_doc_type3 = data.view_tdv_total_doc_type3_aggregate.aggregate.count;
                    var total_doc_type4 = data.view_tdv_total_doc_type4_aggregate.aggregate.count;
                    var total_doc_type5 = data.view_tdv_total_doc_type5_aggregate.aggregate.count;
                    data.total_doc_done = total_doc_normal_tt_gn_nt3 + total_doc_normal_kt + total_doc_normal_ny + total_doc_type3 + total_doc_type4 + total_doc_type5;*/
                    data.total_inventory = data?.total_inventory_key ?? 0;
                },
            },
            // total_doc_remaining: {
            //     name: 'total_doc_remaining', 
            //     type: "Int",
            //     label: 'Văn bản tồn',
            //     width: 8,
            //     class: "center",
            //     // filter: { type: 'input', match: 'contains'},
            //     // display: false
            //     computed: (data) => {
            //         data.total_doc_remaining = data?.view_tdv_total_doc_remaining_aggregate?.aggregate?.count
            //     },
            // },
        },)
    }

}